<template>
  <v-container pa-0 ma-0 fluid>
    <div class="section_inner mt-6">
      <div class="banner-wrap">
        <Banner class="pc-banner " :is-hitech="false" />
      </div>
      <v-row class="mt-7">
        <v-col cols="12" md="9">
          <ContactUsForm :formSubmited="checkCookie" />
        </v-col>
        <v-col cols="12" md="3" class="hidden-sm-and-down">
          <PublishJobAd />
          <SectionCompaniesInnerPages :page="'contactUsPage'" :limitSideBanners="true" />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import ContactUsForm from '@/components/Forms/ContactUsForm/ContactUsForm'
import Banner from '@/components/Jobs_List/Banner'
import SectionCompaniesInnerPages from '@/components/Jobs_List/SectionCompaniesInnerPages'
import PublishJobAd from '@/components/Jobs_List/Ads/PublishJobAd'

export default {
  layout: 'innerPage',
  name: 'contactUsPage',

  components: {
    ContactUsForm,
    Banner,
    SectionCompaniesInnerPages,
    PublishJobAd,
  },
  head() {
    return {
      title: 'צור קשר - דרושים IL',
      meta: [
        {
          name: 'description',
          content:'עמוד צור קשר מכיל את כל השאלות והתשובות הפופולריים באתר דרושים IL. בנוסף, ניתן ליצור קשר ולפנות אלינו לעזרה ונשמח לעמוד לרשותכם.',
          hid: 'DESCRIPTION',
        },
      ],
    }
  },

  data() {
    return {
      formSubmited: false,
    }
  },

  computed: {
    checkCookie() {
      return this.$cookies.get('drushim_ContactUs') ? true : false
    },
  },
  mounted() {
    // this.formSubmited = this.$cookies.get('drushim_ContactUs') ? true : false
  },
}
</script>

<style scoped>
</style>
